// Only values with real markup are rendered as rich text (EHRs like CentralReach store
// rich-text descriptions); plain text such as "a < b" is left alone.
const HTML_TAGS = new Set([
  "p",
  "br",
  "div",
  "span",
  "ul",
  "ol",
  "li",
  "b",
  "strong",
  "i",
  "em",
  "u",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "table",
  "thead",
  "tbody",
  "tr",
  "td",
  "th",
  "blockquote",
  "pre",
  "code",
  "hr",
  "sub",
  "sup",
  "font",
]);
const TAG = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

export const looksLikeHtml = (value: string): boolean =>
  [...value.matchAll(TAG)].some(([, name]) => HTML_TAGS.has(name.toLowerCase()));
